/** A vendor's own view: where their signup stands, in plain words. */
import React from "react";
import { Check } from "lucide-react";
import { useMyVendor } from "@/services/python-api/customerHooks";
import { Card, Empty, Loading, Page, Pill, day } from "../customer/parts";

export default function VendorHome() {
  const { data, isLoading } = useMyVendor();
  const v = data;
  return (
    <Page title="Your Dockie account">
      {isLoading ? (
        <Loading />
      ) : !v ? (
        <Empty title="No application yet">Apply at /work-with-dockie and it shows here.</Empty>
      ) : (
        <div className="space-y-4">
          <Card>
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-[13px] text-[#667185]">{v.kind}</p>
                <p className="text-[20px] font-semibold text-[#101928]">{v.company}</p>
              </div>
              <Pill
                tone={
                  v.state === "approved"
                    ? "bg-[#E7F6EC] text-[#036B26]"
                    : v.state === "declined"
                    ? "bg-[#F0F2F5] text-[#344054]"
                    : "bg-[#EFF6FF] text-[#1D4ED8]"
                }
              >
                {v.state === "applied" ? "Being checked" : v.state === "approved" ? "Active" : "Declined"}
              </Pill>
            </div>
            <p className="mt-3 text-[16px] text-[#101928]">{v.headline}</p>
            <ol className="mt-4 space-y-3">
              {v.steps.map((s) => (
                <li key={s.label} className="flex items-start gap-3">
                  <span
                    className={`mt-0.5 flex h-5 w-5 items-center justify-center rounded-full ${
                      s.done ? "bg-[#2563EB]" : "border-2 border-[#D0D5DD]"
                    }`}
                  >
                    {s.done ? <Check size={12} color="white" /> : null}
                  </span>
                  <span>
                    <span className={`block text-[14px] ${s.done ? "font-medium text-[#101928]" : "text-[#667185]"}`}>{s.label}</span>
                    {s.on || s.note ? <span className="block text-[12px] text-[#667185]">{s.note || day(s.on)}</span> : null}
                  </span>
                </li>
              ))}
            </ol>
          </Card>
          <Card className="divide-y divide-[#F0F2F5] py-1">
            {v.answers.map((a) => (
              <div key={a.label} className="flex justify-between gap-4 py-2.5 text-[14px]">
                <span className="text-[#667185]">{a.label}</span>
                <span className="text-right font-medium text-[#1D2739]">{a.value}</span>
              </div>
            ))}
            {v.documents.map((d) => (
              <div key={d.name} className="flex justify-between gap-4 py-2.5 text-[14px]">
                <span className="text-[#667185]">{d.label}</span>
                <span className="text-right text-[#1D2739]">{d.name}</span>
              </div>
            ))}
          </Card>
        </div>
      )}
    </Page>
  );
}
